/**
 * SlopeLegend - Легенда уклонов
 *
 * Мигрирована на новую систему легенд (Этап 2)
 * Использует LegendRenderer с типом COLORED_ITEMS и иконкой RECT
 */

import React from 'react';
import { connect } from 'react-redux';
import { LegendRenderer } from '../../LegendRenderer';
import { SLOPE_LEGEND } from '../../../constants/legends';

const SlopeLegendComponent = ({ terrainMode }) => {
    // Only show legend when mode is 'Slope' (not 'hillshade', 'aspect', etc.)
    if (terrainMode !== 'Slope') {
        return null;
    }

    return (
        <LegendRenderer config={SLOPE_LEGEND} />
    );
};
const mapStateToProps = ({ map: { terrainMode } }) => ({ terrainMode });
const ConnectedComponent = connect(mapStateToProps)(SlopeLegendComponent);

export const SlopeLegend = ConnectedComponent;
